export const createDocumentToolMessage = (toolMessage: any, results: any, toolName: string) => {
    let fileType = '';
    if (toolName === "createPdf") fileType = "PDF";
    else if (toolName === "createDocx") fileType = "DOCX";

    const content = [{
        type: 'text',
        text: `Here is your ${fileType}. The user can not see it yet, so you have to link it to the user like this:\n[<File_Name>](${results.docUrl})`
    }];

    return {...toolMessage, content: content}
}